/* eslint-disable global-require */
import React from 'react';

/* eslint-disable react/jsx-one-expression-per-line */
export const firstCards = [
    {
        title: <>Распределяющие шляпы<br /> с разноцветными m&amp;m's!</>,
        desc: "Вафельную основу заливаем шоколадом, а внутрь прячем драже M&M's. Она не кричит «Гриффиндор!», а шепчет: «Съешь меня». Откусите и узнайте свой факультет по цвету. Шляпа не ошибается.",
        img: require('./img/_1.jpg'),
    },
    {
        title: <>Мётлы «Нимбус 2000» <br /> с сырным соусом</>,
        desc: 'Метла, которая не требует полётов — только полёт фантазии. Крутим сладко-солёные мётлы из соломки, окунаем в сырный соус и получаем 150 очков к наслаждению.',
        img: require('./img/_2.jpg'),
    },
    {
        title: <>Шоколадный мусс <br /> «Корень мандрагоры»</>,
        desc: 'Те самые кричащие корни мандрагоры, но теперь из ириса. Шоколадный мусс с ирисом — и ни одного обморока на уроке травологЭта мандрагора кричать не будет, но точно околдует вас эндорфинами. Накрываете шоколадный мусс «землёй» и «сажаете» мандрагору из ириса в горшочек — наушники не понадобятся.',
        img: require('./img/_3.jpg'),
    },
    {
        title: <>Урок зельеварения <br /> (синий анчан-лимонад)</>,
        desc: 'Это настоящая магия: лимонад с вау-эффектом! Варим зелье из цветков анчана — сначала оно синее, но секретный ингредиент изменит его цвет. Оценят и любители алхимии и... лимонадов. ',
        img: require('./img/_4.jpg'),
    },
    {
        title: <>Сливочное пиво <br /> от мадам Розмерты</>,
        desc: 'Наконец узнаем, какое оно на вкус! Фантазийный напиток на основе сливочной солёной карамели. И, конечно, — пенка из сливок (для молочных усиков, как у посетителей паба «Три метлы»).',
        img: require('./img/_5.jpg'),
    },
];
